import React, {useEffect, useState, useRef} from 'react';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { compose, contains, is, toUpper } from 'ramda';
import connect from 'react-redux/es/connect/connect';
import moment from 'moment';
import { Map, List } from 'immutable';
import styleFile from './header.js';

import { StepCursor } from '../StepCursor';
import { RichText, Icon, Button } from '@synergycms_core/components/generic';
import { getReservationTotals,concatChildAgeText } from '../../../utils';
import { validateAsyncComponent } from '../../HoC';
import { AvailMainSideSummary } from '../AvailMainSideSummary';
import Modal from '@synergycms_core/components/generic/Modal';
import Price from '@synergycms_core/components/generic/Price';
import actions from '../../../store/actions';
import classnames from 'classnames/bind';
import SearchOptions from '../SearchOptions';
import AvailEngine from '../AvailEngine';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import TooltipWrapper from '@synergycms_core/components/generic/TooltipWrapper';
//import Image from '@synergycms_core/components/generic/Image';
import { Image } from '@synergycms_core/components/generic';
import { contextualizeAppConfig } from "@synergycms_core/store/app/utils";


const defaultHeaderConfig = {
  "show_logo": "",
  "engine_box": "multiHotelAvail;monoHotelAvail;serviceHotelAvail",
  "login_module": "",
  "lang_selector": "",
  "step_cursor": "monoHotelAvail;serviceHotelAvail;customerForm",
  "show_phone": "",
  "avail_info_theme": "complete",
  "phone_number": null
};

function formatDateStrings(dateStart, dateEnd) {
  const startMoment = moment.isMoment(dateStart) ? dateStart : moment(dateStart);
  const endMoment = moment.isMoment(dateEnd) ? dateEnd : moment(dateEnd);
  const sameMonth = startMoment.format('MMM') === endMoment.format('MMM');

  let dateStartFormated, dateEndFormated;

  if (sameMonth) {
    dateStartFormated = startMoment.format('D');
    dateEndFormated = endMoment.format('D MMM');
  } else {
    dateStartFormated = startMoment.format('D MMM');
    dateEndFormated = endMoment.format('D MMM');
  }

  return { dateStartFormated, dateEndFormated };
}

const ReservationInfo = compose(withThemeJSS({ styleFile, displayName: 'Header' }))(
  (props) => {
    const { city, country, params, theme, availInfoTheme, stayLength } = props;

    const { classes } = theme.styles;
    const dateStart = moment(params.get('date'));
    const dateEnd = moment(params.get('date'))
      .add(params.get('stay_length'), 'days');

    const cx = props.theme.bind();

    const destination =
      (city.size && city) || (country.size && country) || Map();
    
    const destinationFilled =
    props.currentStep.get('type') === 'mono'
      ? props.hotel.get('name', '')
      : destination.get('name', '');

    const renderMinimalView = () => {
      return (
        <>{destinationFilled.trim() !== '' && (
            <div className={[classes.locContainer, classes.minLocationContainer].join(' ')}>
              <RichText
                icon={{ unicodeContent: 'e088', innerStyle: ['size23'] }}
                innerStyle={[classes.headerTitle, classes.destinationIcon]}
              />
              <RichText
                translate={true}
                ucFirst={true}
                innerStyle={classes.supTitle} />
              <div className={classes.hotelNameContainer}>
                <RichText text={destinationFilled} innerStyle={[classes.headerTitle, classes.hotelName, classes.engineClosedTitles]} />
                {props.currentStep.get('type') === 'mono' &&
                  props.hotel.get('stars', '') !== '0*' && (
                    <RichText
                      text={props.hotel.get('stars', '')}
                      innerStyle={[classes.headerTitleStars, 'uppercase', classes.engineClosedTitles]} />
                  )}
              </div>
            </div>
          )}<div className={[classes.floatedContainer, classes.minimalDateContainer].join(' ')}>
            <div className={classes.dateContainer}>
              <RichText
                icon={{ unicodeContent: 'e151', innerStyle: ['size23'] }}
                innerStyle={[classes.headerTitle, classes.calendarIcon]}
              />
              <DateInfo
                dateStart={dateStart}
                dateEnd={dateEnd}
                mode={availInfoTheme}
              />
            </div>
          </div></>
      );
    };

    const renderMinimalMobileView = () => {
      return (
        <div className={classes.floatedContainer}>
          {destinationFilled.trim() !== '' && (
            <div className={[classes.locContainer, classes.mobileLocContainer].join(' ')}>
              <div className={classes.hotelNameContainer}>
                <RichText text={destinationFilled} innerStyle={[classes.headerTitle, classes.hotelName, classes.engineClosedTitles]} />
                {props.currentStep.get('type') === 'mono' &&
                  props.hotel.get('stars', '') !== '0*' &&
                  props.theme.width > 901 && (
                    <RichText
                      text={props.hotel.get('stars', '')}
                      innerStyle={[classes.headerTitleStars, 'uppercase', classes.engineClosedTitles]}
                    />
                  )}
              </div>
            </div>
          )}
          <div className={[classes.dateContainer, classes.mobileDateContainer].join(' ')}>
            <RichText
              icon={{
                unicodeContent: 'e151', innerStyle: ['size16'],
              }}
              innerStyle={classes.supTitle}
            />
              <DateInfo
                dateStart={dateStart}
                dateEnd={dateEnd}
                mode={availInfoTheme}
              />
            <RichText
              text={'_%{value} noche%_'}
              withVars={{ value: stayLength }}
              innerStyle={classes.nightsTitle}
              translate={true}
              plural={stayLength !== 1}
            />
          </div>
        </div>
      );
    };

    const renderCompleteView = () => {
      return (
        <div className={classes.floatedContainer}>
          {destinationFilled.trim() !== '' && (
            <div className={classes.locContainer}>
              <RichText
                text={props.theme.width > 900 && (props.currentStep.get('type') === 'mono' ? '_%hotel%_' : '_%destino%_')}
                icon={{ unicodeContent: 'e088', innerStyle: [cx({size22:theme.width > 900, size16:theme.width < 900}), classes.absoluteIcon] }}
                translate={true}
                ucFirst={true}
                innerStyle={classes.supTitle}
              />
              <div className={classes.hotelNameContainer}>
                <RichText text={destinationFilled} innerStyle={[classes.headerTitle, classes.engineClosedTitles]} />
                {props.currentStep.get('type') === 'mono' &&
                  props.hotel.get('stars', '') !== '0*' &&
                  props.theme.width > 901 && (
                    <RichText
                      text={props.hotel.get('stars', '')}
                      innerStyle={[classes.headerTitleStars, 'uppercase', classes.engineClosedTitles]}
                    />
                  )}
              </div>
            </div>
          )}
          <div className={classes.dateContainer}>
            <RichText
              text={props.theme.width > 900 && '_%Fechas%_'}
              icon={{
                svg: 'calendar',
                innerStyle: [classes.absoluteSvg],
              }}
              translate={true}
              ucFirst={true}
              innerStyle={classes.supTitle}
            />
            <DateInfo
              dateStart={dateStart}
              dateEnd={dateEnd}
              mode={availInfoTheme}
            />
          </div>
        </div>
      );
    };

    if (availInfoTheme === 'minimal') {
      if (theme.width > 900) {
        return renderMinimalView();
      } else {
        return renderMinimalMobileView();
      }
    } else {
      return renderCompleteView();
    }
  }
);

const RoomInfo = compose(withThemeJSS({ styleFile, displayName: 'Header' }))((props) => {
  const { theme, params, availInfoTheme } = props;
  const { classes } = theme.styles;
  const cx = props.theme.bind();

  const occups = params.get('occups').reduce((occupCounter, occup) => {
    return occupCounter
    .set('adults', occupCounter.get('adults') + occup.get('adults', 0))
    .set('childs', occupCounter.get('childs') + occup.get('childs', 0))
    .set('childsAge', occupCounter.get('childsAge').concat(occup.get('childsAge',List())));
  }, Map({ adults: 0, childs: 0, childsAge:List() }));

  const childsAge = (props.enableAge && concatChildAgeText({childsInfo :occups.get("childsAge", List()).map(c => c?.get("age"))})) || "";

  const occupsSize = params.get('occups').size;
  const occupsChilds = occups.get('childs');

  const renderMinimalView = () => {
    if (theme.width > 900) {
      return occupsChilds ? (
        <div className={[classes.roomContainer, classes.minimalRoomContainer].join(' ')}>
          <div className={[classes.roomQuantityContainer, classes.minimalRoomOccupContainer].join(' ')}>
            <RichText
              icon={{ unicodeContent: 'e0be', innerStyle: ['size23'] }}
              innerStyle={classes.headerTitle}
            />
            <RichText innerStyle={[classes.roomQuantity, classes.engineClosedTitles]} text={occups.get('adults') + ' · ' + occups.get('childs')} />
          </div>
          <div className={[classes.roomQuantityContainer, classes.minimalRoomQuantityContainer].join(' ')}>
            <RichText
              translate={true}
              ucFirst={true}
              icon={{ unicodeContent: 'e14d', innerStyle: ['size27'] }}
              quantity={occupsSize}
              plural={true}
              innerStyle={classes.headerTitle}
            />
            <RichText text={occupsSize} innerStyle={[classes.roomQuantity, classes.engineClosedTitles]} />
          </div>
        </div>
      ) : (
        <div className={[classes.roomContainer, classes.minimalRoomContainer].join(' ')}>
          <div className={[classes.roomQuantityContainer, classes.minimalRoomOccupContainer].join(' ')}>
            <RichText
              icon={{ unicodeContent: 'e0be', innerStyle: ['size23'] }}
              innerStyle={classes.headerTitle}
            />
            <RichText innerStyle={[classes.roomQuantity, classes.engineClosedTitles]} text={occups.get('adults') + occups.get('childs')} />
          </div>
          <div className={[classes.roomQuantityContainer, classes.minimalRoomQuantityContainer].join(' ')}>
            <RichText
              translate={true}
              ucFirst={true}
              icon={{ unicodeContent: 'e14d', innerStyle: ['size27'] }}
              quantity={occupsSize}
              plural={true}
              innerStyle={classes.headerTitle}
            />
            <RichText text={occupsSize} innerStyle={[classes.roomQuantity, classes.engineClosedTitles]} />
          </div>
        </div>
      );
    } else {
      return (
        <div className={[classes.roomContainer, classes.minimalRoomContainer].join(' ')}>
          <RichText
            icon={{ unicodeContent: 'e0be', innerStyle: ['size16'] }}
            innerStyle={[classes.headerTitle, classes.calendarIcon]}
          />
          {occupsSize > 1 ? (
            <>
              <RichText
                innerStyle={[classes.roomQuantity, classes.engineClosedTitles]}
                translate={true}
                text={occups.get('adults') + ' · ' + occups.get('childs')}
              />
              <div className={[classes.roomQuantityContainer, classes.minimalRoomQuantityContainer].join(' ')}>
                <RichText text={occupsSize} innerStyle={classes.roomQuantity} />
                <RichText
                  translate={true}
                  ucFirst={true}
                  icon={props.theme.width < 901 && { unicodeContent: 'e14d', innerStyle: ['size20'] }}
                  quantity={occupsSize}
                  plural={true}
                  innerStyle={classes.headerTitle}
                />
              </div>
            </>
          ) : occupsChilds ? (
            <>
              <RichText
                innerStyle={[classes.roomQuantity, classes.engineClosedTitles]}
                translate={true}
                text={occups.get('adults') + ' · ' + occups.get('childs')}
              />
              <div className={[classes.roomQuantityContainer, classes.minimalRoomQuantityContainer].join(' ')}>
                <RichText text={occupsSize} innerStyle={classes.roomQuantity} />
                <RichText
                  translate={true}
                  ucFirst={true}
                  icon={props.theme.width < 901 && { unicodeContent: 'e14d', innerStyle: ['size20'] }}
                  quantity={occupsSize}
                  plural={true}
                  innerStyle={classes.headerTitle}
                />
              </div>
            </>
          ) : (
            <>
              <RichText
                innerStyle={[classes.roomQuantity, classes.engineClosedTitles]}
                text={occups.get('adults') + occups.get('childs')}
              />
              <div className={[classes.roomQuantityContainer, classes.minimalRoomQuantityContainer].join(' ')}>
                <RichText text={occupsSize} innerStyle={classes.roomQuantity} />
                <RichText
                  translate={true}
                  ucFirst={true}
                  icon={props.theme.width < 901 && { unicodeContent: 'e14d', innerStyle: ['size20'] }}
                  quantity={occupsSize}
                  plural={true}
                  innerStyle={classes.headerTitle}
                />
              </div>
            </>
          )}
        </div>
      );
    }
  };

  const renderCompleteView = () => {
    return (
      <div className={classes.roomContainer}>
        <RichText
          text={theme.width > 900 && '_%Habitaciones%_'}
          icon={{ unicodeContent: 'e0be', innerStyle: [ cx({size22:theme.width > 900, size16:theme.width < 900}), classes.roomIcon] }}
          translate={true}
          ucFirst={true}
          innerStyle={classes.supTitle}
        />
        <RichText
          innerStyle={classes.roomQuantity}
          text={props.theme.width > 900 ? occups.get('adults') : 'x ' + (occups.get('adults') + occups.get('childs'))}
        />
        {props.theme.width > 900 && (
          <RichText
            translate={true}
            ucFirst={true}
            quantity={occups.get('adults')}
            text={'_%adulto%_'}
            innerStyle={classes.headerTitle}
          />
        )}
        {props.theme.width > 900 && occups.get('childs') > 0 && (
          <React.Fragment>
            <RichText
              innerStyle={classes.roomQuantity}
              text={occups.get('childs')}
            />
            <RichText
              translate={true}
              ucFirst={true}
              quantity={occups.get('childs')}
              text={'_%niño%_'}
              innerStyle={classes.headerTitle}
            />
          </React.Fragment>
        )}{' '}
        {props.theme.width > 900 && occups.get('childs') > 0 && childsAge && (
        <React.Fragment>
          <TooltipWrapper
            popover={<span>{childsAge}</span>}
            bottomLimit={100}
            popoverStyle={classes.yearsTooltip}
            typeTooltip={'occupInfoTooltip'}
            pointerStyle={classes.tooltipPointerStyle}
            posX={'middle'}
            posY={'bottom'}>
            <Image unicodeContent="e143" innerStyle={['gold']}/>
          </TooltipWrapper>{'  '}
        </React.Fragment>
        )}
        <div className={classes.roomQuantityContainer}>
          <RichText text={props.theme.width > 900 ? '- ' + params.get('occups').size : 'x ' + params.get('occups').size} innerStyle={classes.roomQuantity} />
          <RichText
            translate={true}
            ucFirst={true}
            icon={props.theme.width < 901 && { unicodeContent: 'e14d', innerStyle: ['size16'] }}
            quantity={params.get('occups').size}
            plural={true}
            text={props.theme.width > 900 && '_%Hab%_'}
            innerStyle={classes.headerTitle}
          />
        </div>
      </div>
    );
  };

  if (availInfoTheme === 'minimal') {
    return renderMinimalView();
  } else {
    return renderCompleteView();
  }
});

const DateInfo = compose(withThemeJSS({ styleFile, displayName: 'Header' }))(props => {
  const { theme, dateStart, dateEnd, mode } = props;
  const { classes } = theme.styles;

  const isDateInvalid = moment(dateStart).startOf('day').isBefore(moment().startOf('day'));

  const { dateStartFormated, dateEndFormated } = formatDateStrings(dateStart, dateEnd, mode);

  if(isDateInvalid) {
    return (
      <>
        <RichText ucFirst={true} translate={true} text={'_%entrada%_'} innerStyle={classes.headerTitle} />
        <RichText text={' - '} innerStyle={classes.headerTitle}/>            
        <RichText ucFirst={true} translate={true} text={'_%salida%_'} innerStyle={classes.headerTitle} />
      </>
    );
  }

  return <RichText text={[dateStartFormated, ' - ', dateEndFormated].join(' ')} innerStyle={classes.headerTitle} />

});

const SearchButton = compose(withThemeJSS({ styleFile, displayName: 'Header' }))(props => {
  const { classes } = props.theme.styles;
  const { availInfoTheme } = props;

  const richTextProps = {
    translate: true,
  }

  if (availInfoTheme === 'minimal') {
    richTextProps.innerStyle= ['uppercase'];
    richTextProps.text = '_%modificar%_';
  } else {
    richTextProps.innerStyle= ['uppercase', classes.buttonText];
    richTextProps.icon = {
      content: '',
      innerStyle: ['size17', classes.pencilIcon]
    };

    if(props.theme.width > 1100) {
      richTextProps.text = '_%modificar búsqueda%_';
      richTextProps.icon.innerStyle = ['uppercase', 'size17', classes.pencilIcon];
    }
  }


  return (
    <div className={classes.modifySearch}>
      <Button
        onClick={props.onClick}
        richText={richTextProps}
        translate={true}
        innerStyle={['toggleMainButtonReverse', availInfoTheme === 'minimal' ? classes.minModifySearchBtn : '']}
      />
    </div>
  );
});

const MobilePreheader = compose(withThemeJSS({ styleFile, displayName: 'Header' }))(props => {
  const { classes } = props.theme.styles;
  const { companyPhone, hasHeaderConfig, langActive } = props;

  return (
    <div className={classes.mobilePreheader}>
      <div className={classes.mobilePreheaderContainer}>
        { hasHeaderConfig('show_logo') && <HeaderLogo/> }
        <div className={classes.userConfigsContainer}>
          { hasHeaderConfig('login_module') && <LoginModule/> }
          { hasHeaderConfig('show_phone') && (
            <div className={classes.phoneContainer}>
              <a rel="noopener" href={`tel:${companyPhone}`} className={classes.phoneBox}>
                <Image alt={"phone"} svg={'phone'} innerStyle={[classes.phoneDispoEngine]}/>
              </a>
            </div>
          )}
          { hasHeaderConfig('lang_selector') && <LangSelector langActive={langActive}/> }
        </div>
      </div>
    </div>
  );
});

const LoginModule = compose(withThemeJSS({ styleFile, displayName: 'Header' }))(props => {
  const { classes } = props.theme.styles;
  const [isOpen, setIsOpen] = useState(true);
  const modalRef = useRef(null);

  useEffect(() => {
    const loginRoot = document.getElementById('cms-login-dispo');
    if (loginRoot && !loginRoot.hasChildNodes() && window.frontLoader?.['cms-login']?.render) {
      window.frontLoader['cms-login'].render("cms-login-dispo");
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        !event.target.closest(`.${classes.langSelectorBtn}`) // Evita que el LangSelector evite el cierre
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return <div ref={modalRef} className={classes.loginContainer} id="cms-login-dispo"/>

});

const LangSelector = compose(withThemeJSS({ styleFile, displayName: 'Header' }))(props => {
  const { classes } = props.theme.styles;
  let { langActive } = props;

  if(langActive === 'de') langActive = 'AL'; // xd
  
  const langs = window.CMSElementLangURLs ? window.CMSElementLangURLs : [];

  if(!langs.length){
    return null;
  }

  let currentLang;
  const langList = langs.filter(lang => {
    if(lang.code  === toUpper(langActive)) {
      currentLang = lang;
    }
    return lang.code  !== toUpper(langActive);
  });

  const [collapsedSelector, setCollapsedSelector] = useState(true);
  const selectorRef = useRef(null);

  useEffect(() => {

    function handleEventsOutside(event) {
      if (selectorRef.current && !selectorRef.current.contains(event.target)) {
        setCollapsedSelector(true);
      }
    }

    document.addEventListener('pointerdown', handleEventsOutside);
    document.addEventListener('scroll', handleEventsOutside, true);
    return () => {
      document.removeEventListener('pointerdown', handleEventsOutside);
      document.removeEventListener('scroll', handleEventsOutside, true);
    };
  }, []);

  return (
    <div className={classes.langSelectorContainer} ref={selectorRef}>
      <Button
        onClick={() => setCollapsedSelector(!collapsedSelector)}
        innerStyle={[classes.langSelectorBtn, collapsedSelector ? classes.up : classes.down]}
        rightIcon={{
          svg: 'dropDownArrow',
          innerStyle: [classes.langSelectorIcon, collapsedSelector ? classes.up : classes.down ]
        }}>
        <RichText
          innerStyle={classes.langSelected}
          text={props.theme.width > 1280 ? currentLang.name : currentLang.code}
          ucFirst={true}
        />
      </Button>
      {!collapsedSelector && (
        <ul className={classes.langSelectWrapper}>
          {langList.map(lang => (
            <li key={lang.code}>
              <a href={`${lang.url}${window.location.search}`}>
                {props.theme.width > 1280 ? lang.name : lang.code}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
});

const PhoneSelector = compose(withThemeJSS({ styleFile, displayName: 'Header' }))(props => {
  const { classes } = props.theme.styles;
  const { companyPhone } = props;

  const [collapsedSelector, setCollapsedSelector] = useState(true);
  const selectorRef = useRef(null);

  useEffect(() => {
    function handleEventsOutside(event) {
      if (selectorRef.current && !selectorRef.current.contains(event.target)) {
        setCollapsedSelector(true);
      }
    }

    document.addEventListener('pointerdown', handleEventsOutside);
    document.addEventListener('scroll', handleEventsOutside, true);
    return () => {
      document.removeEventListener('pointerdown', handleEventsOutside);
      document.removeEventListener('scroll', handleEventsOutside, true);
    };
  }, []);

  //if (!companyPhone) return null;

  return (
    <div className={classes.phoneContainer} ref={selectorRef}>
      <Button
        onClick={() => setCollapsedSelector(!collapsedSelector)}
        innerStyle={classes.phoneBox}
        ariaLabel={"_%Mostrar número de teléfono%_" + companyPhone}
      >
        <Image svg={'phone'} innerStyle={[classes.phoneDispoEngine]}/>
      </Button>

      {!collapsedSelector && (
        <div className={classes.phoneWrapper}>
          <a rel="noopener" href={`tel:${companyPhone}`} className={classes.phoneLink}>
            <RichText
              innerStyle={classes.phoneNumber}
              text={companyPhone}
            />
          </a>
        </div>
      )}
    </div>
  );
});

const HeaderLogo = compose(withThemeJSS({ styleFile, displayName: 'Header' }))(props => {
  const { classes } = props.theme.styles;
  const baseUrl = window.location.origin;

  return (
    <Button onClick={() => {return window.location.href = baseUrl}} ariaLabel={'eurostarsCompanyLogo'}>
      <Image svg={'eurostarsCompanyLogo'} alt={'header_logo'} innerStyle={classes.headerLogo}/>
    </Button>
  );

});

const PromoCode = compose(withThemeJSS({ styleFile, displayName: 'Header' }))(props => {
  const { classes } = props.theme.styles;
  return (
    <div className={[classes.roomContainer, classes.promoCodeContainer].join(' ')}>
      <RichText
        icon={{ unicodeContent: 'e06f', innerStyle: ['size23'] }}
        innerStyle={classes.headerTitle}
      />
    </div>
  )
});


class Header extends React.Component {
  static displayName = 'Header';

  constructor(props) {
    super(props);
    this.state = {
      visibleEngine: this.props.config.engineIsVisible
    };
    this.cx = classnames.bind(styleFile);
  }

  showAvailDatePicker = () => {
    this.props.config.showEngine(!this.state.visibleEngine);
    this.setState(
      state => {
        return {
          visibleEngine: !state.visibleEngine
        };
      },
      () => {
        if (this.dummyRef && this.headerRef) {
          this.dummyRef.style.height = this.headerRef.offsetHeight + 'px';
        }
      }
    );
  };

  setFixedHeader = () => {
    if (this.headerRef && this.dummyRef) {
      const headerRef = this.headerRef;

      const dummyRef = this.dummyRef;
      if (dummyRef.getBoundingClientRect().top < 0) {
        headerRef.style.position = 'fixed';
        headerRef.style.top = 0;
      } else {
        headerRef.style.top = null;
        headerRef.style.position = 'static';
      }
      //if (dummyRef.offsetHeight === 0) {
      dummyRef.style.height = headerRef.offsetHeight + 'px';
      //}
    }
  };

  componentWillUnmount() {
    this.dummyRef = null;
    this.headerRef = null;
    document.removeEventListener('scroll', this.setFixedHeader);
  }

  componentDidMount() {
    this.setFixedHeader();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.config.engineIsVisible !== prevState.visibleEngine) {
      return { visibleEngine: nextProps.config.engineIsVisible };
    } else return null;
  }

  hasHeaderConfig = (configName) => {
    const { stepCode, appConfig } = this.props.config;

    const headerConfig = Map(appConfig.get('avail_header', defaultHeaderConfig));
    const configValue = headerConfig.get(configName, '');

    return !configValue ? false : configValue.split(';').includes(stepCode);
  }


  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;
    const {
      params,
      currentStep,
      hotel,
      country,
      city,
      reservationTotals,
      stepCode,
      giftCodeDiscount,
      appConfig,
      langInfo,
      stayLength,
      enableAge
    } = config;


    const cx = this.props.theme.bind();

    const langActive = langInfo.get('code');
    const companyPhone = appConfig.getIn([
      'avail_header',
      'phone_number',
      langActive,
      'translatable_value'
    ], "").replace(/\s/g, "");

    const availInfoTheme = appConfig.getIn(['avail_header','avail_info_theme'], "complete");
    const showLogo = this.hasHeaderConfig('show_logo');

    if (contains(stepCode, ['cancelation', 'newCof'])) {
      return null;
    }

    let dynamicHeader = this.hasHeaderConfig('engine_box') ? (
      <>
        {showLogo && <HeaderLogo/>}
        <div className={classes.leftContainer} onClick={this.showAvailDatePicker}>
          <ReservationInfo
            hotel={hotel}
            params={params}
            currentStep={currentStep}
            country={country}
            city={city}
            stayLength={stayLength}
            availInfoTheme={availInfoTheme} />
          <RoomInfo enableAge={enableAge} availInfoTheme={availInfoTheme} params={params}/>
          {availInfoTheme === 'minimal' && <PromoCode />}
          <SearchButton availInfoTheme={availInfoTheme}/>
        </div>
      </>
    ) : (showLogo && <HeaderLogo/> );

     if (theme.width < 901) {

      dynamicHeader = (
        <>{availInfoTheme === 'minimal' && <MobilePreheader hasHeaderConfig={this.hasHeaderConfig} companyPhone={companyPhone} langActive={langActive} />}
        {currentStep.get('code') !== 'confirmation' && <div className={classes.leftContainer}>
          <div className={[classes.tableContainer, cx({
              miniTableContainer: availInfoTheme === 'minimal'
            })].join(' ')}>
            <Button onClick={this.showAvailDatePicker} innerStyle={classes.leftButton} ariaLabel={"_%destino%_"} translate={true}>
              <ReservationInfo
                hotel={hotel}
                params={params}
                currentStep={currentStep}
                country={country}
                city={city}
                stayLength={stayLength}
                availInfoTheme={availInfoTheme} />
            </Button>
          </div>
          <Modal
            innerStyle={['resumeModalStyle']}
            //contentStyle={classes.testing}
            closeButtonStyle={classes.summaryCloseButton}
            modalStyle={classes.resumeModalStyle}
            defaultStyle={false}
            popover={<AvailMainSideSummary innerStyle={'summaryModal'} />}
            typeModal={'AvailMainSideSummaryTooltip'}>
            <div className={[classes.tableContainer, classes.priceMoreDetails, cx({
              miniTableContainer: availInfoTheme === 'minimal'
            })].join(' ')}>
              <Button ariaLabel={"_%resumen de reserva%_"} translate={true}>
                <div className={classes.floatedContainer}>
                  <div>
                    {reservationTotals && (
                      <Price innerStyle={classes.resumePrice}
                        amount={reservationTotals.get('total_price') + giftCodeDiscount} />
                    )}
                  </div>
                  <div className={classes.arrowContainer}>
                  <RichText
                      innerStyle={classes.headerTitle}
                      translate={true}
                      ucFirst={true}
                      plural={true}
                      text={'_%ver detalles%_'}
                      rightIcon= {{ unicodeContent: langActive === 'AR' ? '005C' : 'e052', innerStyle: ['size12', 'marginLeft5', 'mainColor'] }}/>
                  </div>
                </div>
              </Button>
            </div>
          </Modal>
        </div>}
        </>
      );

      if (contains(currentStep.get('code'), ['multiHotelAvail', 'monoHotelAvail'])) {
        dynamicHeader = (
          <>
            {availInfoTheme === 'minimal' && <MobilePreheader hasHeaderConfig={this.hasHeaderConfig} companyPhone={companyPhone} langActive={langActive} />}
            <Button onClick={this.showAvailDatePicker} innerStyle={classes.datePickerButton} ariaLabel={"_%destino%_"} translate={true}>
              <div className={[classes.tableContainer, cx({
                miniTableContainer: availInfoTheme === 'minimal',
                mobileTableContainer: availInfoTheme === 'minimal'
              })].join(' ')}>
                <ReservationInfo
                  hotel={hotel}
                  params={params}
                  currentStep={currentStep}
                  country={country}
                  city={city}
                  stayLength={stayLength}
                  availInfoTheme={availInfoTheme} />
                {availInfoTheme !== 'minimal' ?
                <RoomInfo params={params} onClick={this.showAvailDatePicker} availInfoTheme={availInfoTheme} /> :
                <div className={classes.mobileRoomInfo}>
                  <div className={classes.modifySearch}>
                    <RichText text={'_%editar%_'} translate={true} innerStyle={['roboto14Black',classes.modifyTitle]} ucFirst={true}/>
                  </div>
                  <RoomInfo params={params} onClick={this.showAvailDatePicker} availInfoTheme={availInfoTheme} />
                </div>
                }
                {availInfoTheme !== 'minimal' && 
                  <div className={[classes.modifySearch].join(' ')}>
                    <Icon content={''} innerStyle={['size17', classes.pencilIcon]} />
                  </div>
                }
              </div>
            </Button>
          </>
        );
      }

    }
    return (
      <React.Fragment>
        <div
          className={this.state.visibleEngine ? classes.opennedEngine : classes.closedEngine}
          ref={dummyRef => {
            if (dummyRef) {
              this.dummyRef = dummyRef;
              this.setFixedHeader();
            }
          }}>
          <header
            className={cx(classes.wrapperHeader, {
              mapFilters: config.searchOptionsIsVisible && theme.width < 1300
            })}
            ref={headerRef => {
              if (headerRef) {
                this.headerRef = headerRef;
                document.removeEventListener('scroll', this.setFixedHeader);
                document.addEventListener('scroll', this.setFixedHeader);
                this.setFixedHeader();
              }
            }}>
            <div className={
              [
                classes.header, 
                theme.computedInnerStyle,
                cx({
                  minimalHeader: availInfoTheme === 'minimal',
                  hasEngine: this.hasHeaderConfig('engine_box')
                })
              ].join(' ')}
            >
              <div
                className={
                  currentStep.get('code') === 'multiHotelAvail' ? classes.multiHotelHeader : classes.headerContainer
                }>
                <div className={classes.infoContainer}>
                  {!this.state.visibleEngine && dynamicHeader}
                  {((!this.state.visibleEngine && theme.width > 970) ||
                    (currentStep.get('code') === 'customerForm' && theme.width > 900)) && (
                      <div className={classes.stepContent}>
                        {this.hasHeaderConfig('step_cursor') && <StepCursor />}
                      </div>
                    )}
                  {this.state.visibleEngine && <AvailEngine />}
                  {!this.state.visibleEngine && theme.width > 900 && availInfoTheme === 'minimal' && (
                    <div className={classes.userConfigsContainer}>
                      {this.hasHeaderConfig('login_module') && <LoginModule/>}
                      {this.hasHeaderConfig('show_phone') && (
                        <>
                          {theme.width >= 1024 ? (
                            <PhoneSelector companyPhone={companyPhone}/>
                          ) : (
                            <div className={classes.phoneContainer}>
                              <a rel="noopener" href={`tel:${companyPhone}`} className={classes.phoneBox}>
                                <Image alt={"phone"} svg={'phone'} innerStyle={[classes.phoneDispoEngine]} />
                              </a>
                            </div>
                          )}
                        </>
                      )}
                      {this.hasHeaderConfig('lang_selector') && <LangSelector langActive={langActive}/>}
                    </div>
                  )}
                </div>
              </div>
              {config.searchOptionsIsVisible && theme.width < 1300 && (
                <SearchOptions innerStyle={['multiHotelSearchOptions', 'mapOptions']} />
              )}
            </div>
          </header>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = store => {
  const hotelId = store.getIn(['customer', 'current_hotel'], null);

  const params = store.getIn(['customer', 'params', 'params'], undefined);
  const urlParams = store.getIn(['customer', 'params', 'url_params'], undefined);

  const country =
    params &&
    params.get('country_id') &&
    store.getIn(['hotels', 'hotels_info', 'countries'], List()).find(country => {
      return country.get('id') === parseInt(params.get('country_id'), 10);
    });

  const city =
    params &&
    params.get('city_id') &&
    store.getIn(['hotels', 'hotels_info', 'cities'], List()).find(city => {
      return city.get('id') === parseInt(params.get('city_id'), 10);
    });

  const reservationBlocks = store.getIn(['customer', 'reservation_request', 'blocks'], null);

  const amountPromoPaid = store.getIn(['customer', 'reservation', 'payment', 'amount_promo_paid'], 0);
  let giftCodeDiscount = 0;
  if (amountPromoPaid > 0) {
    giftCodeDiscount = amountPromoPaid * -1;
  }
  let childsInfo = store.getIn(['hotels', hotelId, 'occups_free'],null);
  const enableAge = (!!childsInfo && Number.isFinite(childsInfo.getIn(["baby", "start"])) && Number.isFinite(childsInfo.getIn(["child","end"])));
  return {
    stepCode: store.getIn(['customer', 'step', 'current_step', 'code']),
    hotel: (!hotelId && Map()) || store.getIn(['hotels', hotelId], Map()),
    currentStep: store.getIn(['customer', 'step', 'current_step']),
    reservationTotals:
    reservationBlocks && is(List, reservationBlocks) && reservationBlocks.size > 0 && getReservationTotals(store),
    params: params || undefined,
    urlParams: urlParams || undefined,
    city: city || Map(),
    country: country || Map(),
    stayLength: store.getIn(['customer', 'params', 'params', 'stay_length']),
    engineIsVisible: store.getIn(['customer', 'header', 'engine']),
    searchOptionsIsVisible: store.getIn(['customer', 'header', 'search_options']),
    giftCodeDiscount: giftCodeDiscount,
    enableAge,
    langInfo: store.getIn(['customer', 'lang_info']),
    appConfig: contextualizeAppConfig(store, hotelId),
  };
};

const mapDispatchToProps = (dispatch, ownProps, state) => {
  return {
    showEngine: show => {
      dispatch(actions.customer.header.show('engine', show));
    }
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps, ['params']),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager([
    'stepCode',
    'currentStep',
    'params',
    'enableAge',
    'hotel',
    'city',
    'country',
    'reservationTotals',
    'urlParams',
    'showEngine',
    'engineIsVisible',
    'searchOptionsIsVisible',
    'giftCodeDiscount',
    'appConfig',
    'langInfo',
    'stayLength'
  ]),
  withThemeJSS({ styleFile, link: true })
)(Header);
